import React from 'react';

import * as S from './styles';
import { Button, Typography } from '@material-ui/core';
import { Close, ReportProblemOutlined } from '@material-ui/icons';
interface Props {
  onClose: () => void;
}

export const EmptyDocs = ({ onClose }: Props) => {
  return (
    <S.Container>
      <S.HeaderEmpty>
        <Button onClick={onClose}>
          <Close />
        </Button>
      </S.HeaderEmpty>
      <S.ContainerMessage>
        <S.IconContent>
          <ReportProblemOutlined />
        </S.IconContent>
        <S.InfoContent>
          <Typography variant="body2">Sem documentos para exibir</Typography>
        </S.InfoContent>
      </S.ContainerMessage>
    </S.Container>
  );
};
